import React, { useState } from 'react'
import FeedVideoCardItem from './item'
import classNames from 'classnames'
import {
  getRelatedRecommend,
  IRelatedRecommendItem,
} from '../../services/index'
import ScrollLoader from 'Components/scroll-loader'
interface IProps {
  title: string
  groupId: string
  videoList: IRelatedRecommendItem[]
  setVideoList?: any
  nextOffset?: number
  isRecommond?: boolean
}
const Floor: React.FC<IProps> = ({
  title,
  groupId,
  videoList,
  setVideoList,
  nextOffset,
  isRecommond,
}) => {
  const [loading, setLoading] = useState(false)
  const [next_offset, setNextOffset] = useState(nextOffset || 0)
  const [hasMore, setHasMore] = useState(true)
  const [isDoudi, setIsDoudi] = useState(isRecommond ? true : false)
  const loadMoreHandler = async () => {
    if (!hasMore || videoList?.length >= 80 || isDoudi) {
      return
    }
    setLoading(true)
    try {
      const data = await getRelatedRecommend(
        null,
        groupId,
        0,
        '',
        20,
        next_offset
      )
      setNextOffset(data?.next_offset)
      setIsDoudi(data?.is_recommend)
      setHasMore(data?.relation_list && data?.relation_list?.length !== 0)
      setVideoList([...videoList, ...(data?.relation_list || [])])
    } finally {
      setLoading(false)
    }
  }

  return (
    <div
      data-log-extra={JSON.stringify({
        module_id: 'related_recommend_v_module',
        related_group_id: groupId,
      })}
      data-log-view-config={JSON.stringify({
        repeated: true,
      })}
      data-log-view={JSON.stringify({
        event: 'show_event',
        params: {
          event_id: 'related_group_module',
        },
      })}
      className="floor-card"
    >
      {!!videoList?.length && <h2 className="title">{title}</h2>}
      <div className={`content-wrap`}>
        <ScrollLoader
          loading={loading}
          loadMoreHandler={loadMoreHandler}
          end={false}
        >
          <div>
            {videoList?.map((item: IRelatedRecommendItem, index: number) => (
              <div
                key={item?.group_id_str}
                className={classNames('tw-h-98 xl:tw-h-102', {
                  border: index !== videoList?.length - 1,
                })}
              >
                <FeedVideoCardItem
                  category={'asdf'}
                  uniqueIdStr={item?.group_id_str}
                  title={item?.title}
                  coverUrl={item?.image_url}
                  duration={item?.video_duration}
                  avatar={item?.user_info?.avatar_url}
                  name={item?.creator_name}
                  publishTime={item?.publish_time}
                  videoWatchCount={item?.count}
                  userId={
                    item?.user_info?.user_id
                      ? String(item?.user_info?.user_id)
                      : ''
                  }
                  userVerified={item?.user_info?.user_verified}
                />
              </div>
            ))}
          </div>
        </ScrollLoader>
      </div>
      <style jsx>
        {`
          .floor-card {
            background: #ffffff;
            padding: 0px 16px;
            margin-top: 24px;
          }
          .title {
            font-size: 20px;
            font-weight: 600;
            color: #1f2129;
            padding: 12px 16px;
            display: flex;
            flex-direction: row;
            align-items: center;
            padding: 12px 0px;
            height: 52px;
          }
          .content-wrap {
            position: relative;
          }
        `}
      </style>
    </div>
  )
}

export default Floor
